<template>
  <div>
    <div class="flex justify-between">
      <label :for="`budget-input-${pkg.package_options[0].id}`" style="font-weight: normal">
        Set your budget
      </label>
      <div class="money">
        <span class="money__symbol">{{ moneySymbol }}</span>
        <input class="money__input" :id="`budget-input-${pkg.package_options[0].id}`"
               v-model="pkg.package_options[0].budget" type="number" min="0" step="10"/>
      </div>
    </div>

    <div v-if="!validation.budget.required" class="help-block">You must set a budget</div>
    <div v-else-if="budgetHint">{{ budgetHint }}</div>
  </div>
</template>

<script>
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  props: {
    pkg: {
      required: true
    },
    validation: {
      required: true
    },
    user: {
      required: true
    }
  },

  computed: {
    budgetHint () {
      const budgetHints = this.pkg.package_options[0].budget_hints

      const budgetHint = budgetHints.filter(element => element.low <= this.pkg.package_options[0].budget && (element.high > this.pkg.package_options[0].budget || element.high === null))[0]

      if (!budgetHint) { return null }

      return budgetHint[this.$user.role] ? budgetHint[this.$user.role] : budgetHint.default
    },

    moneySymbol () {
      if (this.user.region.currency_code === 'points') {
        return 'Pts'
      }
      return getSymbolFromCurrency(this.user.region.currency_code)
    }
  },

  created () {
    this.pkg.package_options[0].opted_in = true
  }
}
</script>
